var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(_vm.componentType, {
    tag: "component",
    attrs: {
      avatar: _vm.avatar,
      members: _vm.members,
      "is-loading": _vm.isLoadingMembers,
      "is-disabled": _vm.isPerformingAction,
    },
    on: {
      "hang-up": _vm.onHangUp,
      "go-back": function ($event) {
        return _vm.$emit("go-back")
      },
      close: function ($event) {
        return _vm.$emit("close")
      },
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }